import Icon from '../components/Icon.vue'

Icon.register({
  'sign-in-alt': {
    width: 512,
    height: 512,
    paths: [
      {
        d: 'M416 448h-84c-6.6 0-12-5.4-12-12v-40c0-6.6 5.4-12 12-12h84c17.7 0 32-14.3 32-32v-192c0-17.7-14.3-32-32-32h-84c-6.6 0-12-5.4-12-12v-40c0-6.6 5.4-12 12-12h84c53 0 96 43 96 96v192c0 53-43 96-96 96zM369 247c9.3 9.4 9.3 24.6 0 34l-168 168c-15 15-41 4.5-41-17v-96h-136c-13.3 0-24-10.7-24-24v-96c0-13.3 10.7-24 24-24h136v-96c0-21.5 26-32 41-17z'
      }
    ]
  }
})



// WEBPACK FOOTER //
// ./~/vue-awesome/icons/sign-in-alt.js